import { NativeDataFetcher, NativeDataFetcherResponse } from '@sitecore-jss/sitecore-jss-nextjs';

export async function dataFetcher<ResponseType>(
  url: string,
  data?: unknown
): Promise<NativeDataFetcherResponse<ResponseType>> {
  const isPost = data !== undefined;

  const fetcher = new NativeDataFetcher({ credentials: 'include' });
  const response = await fetcher.fetch<ResponseType>(url, {
    method: isPost ? 'POST' : 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    body: isPost ? JSON.stringify(data) : undefined,
  });
  return response;
}
export function dataFetcherGet<TResponse>(url: string): Promise<NativeDataFetcherResponse<TResponse>> {
  return dataFetcher<TResponse>(url);
}
